module.exports = __webpack_public_path__ + "static/img/16.3e5fdc96.jpg";